//Redirection Collection Zero
(function () {
  var path = window.location.pathname.replace(/\/$/, '');
  var isEN = path.startsWith('/en/');
  var shouldRedirect =
    path === '/en/collections/zero-old' ||
    path === '/collections/gamme-de-coloration-zero-old';

  if (shouldRedirect) {
    // Empêche tout affichage visuel
    document.documentElement.style.display = 'none';

    // Ajoute la balise noindex pour que Google ne l’indexe pas
    document.head.insertAdjacentHTML(
      'beforeend',
      '<meta name="robots" content="noindex, nofollow">'
    );

    // Redirection immédiate
    window.location.replace(
      isEN ? '/en/collections/art-absolute' : '/collections/art-absolute'
    );
  }
})();
